export const sizes = {
  tiny: 0,
  xsmall: 444,
  small: 625,
  medium: 806,
  large: 987,
  xlarge: 1168,
  huge: 1440
};

for (const key in sizes) {
  sizes[sizes[key]] = key;
}

export const maxWidth = value => {
  value = sizes[value] || value;
  return `(max-width: ${value / 16}em)`;
};

export const minWidth = value => {
  value = sizes[value] || value;
  return `(min-width: ${value / 16}em)`;
};

export const range = (min, max) => {
  return `${minWidth(min)} and ${maxWidth(max)}`;
};

export const getScreenCode = data => {
  for (const key of Object.keys(data)) {
    if (data[key]) {
      return sizes[key];
    }
  }
  return -1;
};



// WEBPACK FOOTER //
// ./src/app/media.js